import QuantitySelector from '../../../common/components/QuantitySelector/QuantitySelector';
import Toggle from '../../../common/components/Toggle/Toggle';
import React from 'react';


const AttentionCard = ({
                           attention,
                           editable,
                           attentionForCreate,
                           reCalcAmount,
                           deleteAttention,
                           addAttention,
                           showAmount,
                           handleChangeCount,
                           disable,
                       }) => {
    const getTitle = () => {
        switch (attention.status) {
            case 'NOT_COVERED_BY_PLAN':
                return 'El plan no cubre esta atención';
            case 'NOT_ENOUGH_DAYS_TO_PAY':
                return 'Aun no se completó la carencia necesaria';
            case 'COVERED_BY_SESSION':
                return attention?.planName ? attention?.planName : '';
            case 'NO_MORE_AVAILABLE_SESSIONS':
                return 'No posee más sesiones disponibles';
            case 'COVERED_BY_PLAN':
                return attention?.planName ? attention?.planName : '';
            default:
                return '';
        }
    };

    const calcAmount = (e) => {
        attention.amount = parseInt(e.target.value);
        reCalcAmount();
    };


    const handleChange = (newValue) => {
        handleChangeCount(attention.medicalServiceId, newValue);
    };

    return (
        <div className="ul-div-form vu-content mb-50 vu-size" style={{flex: '1'}}>
            <div className="vu-title">
                <div style={{
                    display: 'flex',
                    maxWidth: '60%',
                }}>
                    <text className="vu-name" style={{
                        display: 'inline-block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                        {attention?.medicalServiceName.slice(0, 40)}
                    </text>
                </div>
                {attention?.tariff === 'SI' ?
                    attention?.needInputAmount ?
                        <div>
                            <div className="vu-name">
                                <text>Ingrese el monto: $</text>
                                <input className="vu-name input-amount" type="number" pattern="[0-9]*" min={0}
                                       onChange={(e) => calcAmount(e)} value={attention.amount}/>
                            </div>
                        </div> :
                        <div>

                            {showAmount &&
                                <text className="vu-name amount">Debe abonar: ${attention?.needsToPay}</text>}

                        </div> :
                    attention?.needsToPay === 0 ?
                        <div className="vu-name">
                            <text>Cubierto</text>
                        </div> :
                        showAmount ? <div className="vu-name amount">
                                <text>Debe abonar: $</text>
                                <text className="vu-name amount">{attention?.needsToPay}</text>
                            </div> :
                            attention?.tariff === 'NO' && attention?.needsToPay === 0 &&
                            <div className="vu-name amount">
                                <text>Debe abonar: $</text>
                                <text className="vu-name amount">{attention?.needsToPay}</text>
                            </div>
                }
            </div>
            <form className="vu-form">
                <div>
                    <div className="ca-div-container">
                        <div>
                            <div className="vu-row-data">
                                <text>{getTitle()}</text>
                            </div>
                            <div className="vu-row-data">
                                <text>Rubro:</text>
                                <text>{attention?.medicalServiceCategory}</text>
                            </div>
                            {(attention.status === 'COVERED_BY_SESSION' || attention.status === 'NO_MORE_AVAILABLE_SESSIONS') &&
                                <div className="vu-row-data">
                                    <text>Sesiones:</text>
                                    <text>{attention?.usedSessions} / {attention?.totalSessions}</text>
                                    {attention.status === 'COVERED_BY_SESSION' && <text> - Sesión habilitada</text>}
                                </div>
                            }
                            <div className="vu-name">
                                <text> {attention?.tariff === 'SI' ? 'Posee arancel preferencial' : attention?.needsToPay === 0 ? 'NO ABONA' : attention?.tariff === 'NO' ? 'Paga copago' : 'Posee arancel preferencial'}</text>
                            </div>
                        </div>

                    </div>
                </div>
                {editable && <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '5px',
                }}>
                    <QuantitySelector handleChange={(v) => handleChange(v)} disable={disable}></QuantitySelector>
                </div>}
            </form>
            {editable &&
                <div className="ca-div-container">
                    <div style={{textAlign: 'center', marginBottom: '20px'}}>
                        <Toggle
                            handleChange={(v) => v ? deleteAttention(attention.medicalServiceId) : addAttention(attention.medicalServiceId)}/>
                    </div>
                </div>
            }
        </div>

    )
        ;
};
export default AttentionCard;
